import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BoardIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 11H20M12 8H12.008M9 8H9.008M6 8H6.008M5 19H19C20.105 19 21 18.105 21 17V7C21 5.895 20.105 5 19 5H5C3.895 5 3 5.895 3 7V17C3 18.105 3.895 19 5 19Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

BoardIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(BoardIcon);
